import React from 'react';
import { common_container } from '../TopCard';
import DealsListDesktopView from './Desktop';
import { Deals } from '../../../../deals/redux/types';
import DealsGridView from '../GridView';

type Props = {
    list: Deals[];
};

const DealListView: React.FC<Props> = ({ list }) => {
    return (
        <div>
            <div className={`hidden md:flex ${common_container}`}>
                <DealsListDesktopView list={list} />
            </div>
            <div className={`flex md:hidden ${common_container}`}>
                <DealsGridView list={list} />
            </div>
        </div>
    );
};

export default DealListView;
